import { motion } from "framer-motion";
import Seo from "@/components/Seo";
import { Opening } from "@/components/site/Opening";
import { Statement } from "@/components/site/Statement";
import { ServicesSummary } from "@/components/site/ServicesSummary";
import { FeaturedWorks } from "@/components/site/FeaturedWorks";
import { CtaBand } from "@/components/site/CtaBand";

const JSON_LD = {
    "@context": "https://schema.org",
    "@type": "AutoWash",
    name: "Ramljak – Auto Detailing Centar",
    description:
        "Profesionalno dubinsko čišćenje, poliranje i detailing automobila u Ljubuškom.",
    telephone: "+38763640050",
    address: {
        "@type": "PostalAddress",
        streetAddress: "Ulica Hrvatskih kraljeva 35",
        addressLocality: "Ljubuški",
        postalCode: "88320",
        addressCountry: "BA",
    },
    hasMap: "https://maps.app.goo.gl/2zMh6MGEH4rkaogc6",
    openingHoursSpecification: [
        {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            opens: "08:00",
            closes: "17:00",
        },
        {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: "Saturday",
            opens: "08:00",
            closes: "14:00",
        },
    ],
};

export default function HomePage() {
    return (
        <motion.main
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            <Seo
                title="Ramljak Auto Detailing Centar | Dubinsko čišćenje i poliranje | Ljubuški"
                siteName="Ramljak Auto Detailing Centar"
                description="Ramljak Auto Detailing Centar u Ljubuškom – profesionalno dubinsko čišćenje, poliranje i detailing automobila. Kontaktirajte nas i rezervirajte termin."
                jsonLd={JSON_LD}
            />
            <Opening />
            <Statement />
            <ServicesSummary />
            <FeaturedWorks />
            <CtaBand />
        </motion.main>
    );
}
